import React, { useState, useEffect, useRef } from 'react';
import { Outlet, Navigate, useParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../utils/api';

const GroupSlugWrapper: React.FC = () => {
  const { groupSlug } = useParams<{ groupSlug: string }>();
  const [status, setStatus] = useState<'loading' | 'valid' | 'invalid'>('loading');
  const { user } = useAuth();
  const lastSlug = useRef<string | null>(null);

  useEffect(() => {
    if (!groupSlug || !user) return;
    if (lastSlug.current === groupSlug) return;
    lastSlug.current = groupSlug;

    setStatus('loading');
    api.get<{ id: string; slug: string; name?: string; logoUrl?: string | null }>(`/api/property-groups/slug/${groupSlug}`)
      .then(res => {
        localStorage.setItem('selectedPropertyGroup', res.data.id);
        localStorage.setItem('selectedPropertyGroupSlug', groupSlug);
        // Prime branding cache so the per-property logo paints immediately
        // when Layout mounts, before useBranding's network refresh completes.
        localStorage.setItem('activeBranding', JSON.stringify({
          id: res.data.id,
          slug: res.data.slug,
          name: res.data.name,
          logoUrl: res.data.logoUrl ?? null,
        }));
        setStatus('valid');
      })
      .catch(() => {
        setStatus('invalid');
      });
  }, [groupSlug, user]);

  if (status === 'loading') {
    return (
      <div className="flex items-center justify-center h-screen bg-[#0f0f10] text-white">
        <div className="flex items-center gap-3">
          <div className="w-5 h-5 border-2 border-[#22d3ee] border-t-transparent rounded-full animate-spin" />
          <span className="text-white/60">Loading...</span>
        </div>
      </div>
    );
  }

  if (status === 'invalid') {
    return <Navigate to="/select-group" replace />;
  }

  return <Outlet />;
};

export default GroupSlugWrapper;
